module.exports = __webpack_public_path__ + "img/GoldstarHaulageROT.07e7e469.png";